export default __webpack_public_path__ + "static/branches-bg-8a7f7d019d8853d00b5dad60191e2275.png";